export default __webpack_public_path__ + "static/media/myb-chatbot.8c7ea81f.png";